export default "__VITE_ASSET__Dz8HYZCi__"